module.exports = __webpack_public_path__ + "static/media/stock-wedding-aisle.672b1dc8.jpg";